export enum AdresseTypes {
  FETCH_ADRESSE = 'FETCH_ADRESSE',
  FETCH_CITIES = 'FETCH_CITIES',
  SET_SELECTED_CITIES = 'SET_SELECTED_CITIES',
}
